module.exports = __webpack_public_path__ + "static/media/github.6345c3a1.svg";